import ComponentStatus from 'components/ComponentStatus';
import React from 'react';
export default {
  ComponentStatus,
  React
};